import { environment } from '../../environments/environment';

export type ApiHost = 'kiln' | 'claim';

export function getHttpStatus(error: unknown): number | undefined {
  if (typeof error === 'object' && error !== null && 'status' in error) {
    const status = (error as { status?: unknown }).status;
    return typeof status === 'number' ? status : undefined;
  }
  return undefined;
}

/** True when failure is likely due to network, DNS, or upstream gateway issues (not app/auth logic). */
export function isLikelyConnectivityError(error: unknown): boolean {
  if (error == null) {
    return true;
  }
  const status = getHttpStatus(error);
  return status === 0 || status === 502 || status === 503 || status === 504;
}

export function getApiHostFromUrl(url: string): ApiHost | null {
  if (url.includes(environment.kilnApi)) {
    return 'kiln';
  }
  if (url.includes(environment.claimApi)) {
    return 'claim';
  }
  return null;
}

export function isKilnStatusApiUrl(url: string): boolean {
  return url.includes(environment.kilnApi) && url.includes('/kilns/view');
}

export function is503Error(error: unknown): boolean {
  return getHttpStatus(error) === 503;
}
